import React from 'react'
import { Box, Tab, Tabs } from '@mui/material';
import LiveHistorique from '../historique/LiveHistorique.js';
import LiveImport from '../import/LiveImport.js';
import LiveHeader from '../header/LiveHeader.js';
import TabPanel from '../../../dsasComponents/TabPanel.js';
import a11yProps from '../../../dsasComponents/a11yProps.js';

const ActuInLive = ({actu, liveId}) => {

    const [value, setValue] = React.useState(0);
  
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
  
    return (
      <>
                  <LiveHeader match={actu}/>
                  
                  <Box sx={{ width: '100%' }}>
                      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" indicatorColor="secondary" textColor="inherit" variant="fullWidth" >
                            <Tab label="Import" {...a11yProps(1)} />
                            <Tab label="Historique" {...a11yProps(2)} />
                          </Tabs>
                      </Box>
                      <TabPanel value={value} index={0}>
                          <LiveImport match={actu} liveId={liveId}/>
                      </TabPanel>
                      <TabPanel value={value} index={1}>
                          <LiveHistorique match={actu}/>
                      </TabPanel>
                  </Box>
      </>
    )
  
  }

export default ActuInLive